import Loadable from 'UIComponents/decorators/Loadable';
import AsyncComponentLoading from './AsyncComponentLoading';
import AsyncComponentError from './AsyncComponentError';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = props =>
/*#__PURE__*/
// @ts-expect-error ts-migrate(2786) FIXME: 'AsyncComponentLoading' cannot be used as a JSX co... Remove this comment to see the full error message
_jsx(AsyncComponentLoading, Object.assign({}, props));
LoadingComponent.displayName = 'AsyncInboxZeroState';
const AsyncInboxZeroState = Loadable({
  loader: () => import( /* webpackChunkName: "inbox-zero-state" */'../../unified-inbox/components/zero-states/InboxZeroState'),
  LoadingComponent,
  ErrorComponent: AsyncComponentError
});
export default AsyncInboxZeroState;